interface RuleTypesListProps {
  variant: "earn" | "reward";
}

export function RuleTypesList({ variant }: RuleTypesListProps) {
  const earnRuleTypes = [
    { name: "validity", desc: "Active during a date range" },
    { name: "time_range", desc: "Only within specific hours" },
    { name: "week_days", desc: "On specific days of the week" },
    { name: "service_type", desc: "Takeout, dine out, delivery, etc." },
    { name: "min_order_total", desc: "Minimum cart value required" },
    { name: "categories", desc: "Specific menu categories only" },
    { name: "menu_items", desc: "Specific menu items only" },
    { name: "nth_order", desc: "Every Nth order earns extra" },
    { name: "new_customer", desc: "First-time customers only" },
    { name: "tags", desc: "Filter by custom order tags" },
  ];

  const earnEffectTypes = [
    { name: "flat", desc: "Fixed amount of Kudoz earned" },
    { name: "percentage", desc: "Percentage of order total" },
    { name: "multiplier", desc: "Boost existing Kudoz earnings" },
    { name: "round_up", desc: "Round up points to nearest value" },
  ];

  const rewardRuleTypes = [
    ...earnRuleTypes,
    { name: "min_kudoz_balance", desc: "Minimum points to redeem" },
  ];

  const rewardEffectTypes = [
    { name: "flat", desc: "Fixed-amount discount" },
    { name: "percentage", desc: "Percentage discount" },
    { name: "free_delivery", desc: "Free delivery benefit" },
    { name: "free_item", desc: "Free menu item" },
    { name: "kudoz_balance_deduction", desc: "Deduct points from wallet" },
    { name: "gift_certificate", desc: "Gift credit or certificate" },
  ];

  const ruleTypes = variant === "earn" ? earnRuleTypes : rewardRuleTypes;
  const effectTypes = variant === "earn" ? earnEffectTypes : rewardEffectTypes;

  return (
    <div className="grid md:grid-cols-2 gap-6">
      <div className="space-y-3">
        <h5 className="text-sm font-semibold text-foreground flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-info" />
          Rule Types
        </h5>
        <ul className="space-y-2">
          {ruleTypes.map((rule) => (
            <li key={rule.name} className="flex items-start gap-2 text-sm">
              <code className="px-1.5 py-0.5 bg-muted rounded text-xs font-mono text-muted-foreground shrink-0">
                {rule.name}
              </code>
              <span className="text-muted-foreground">{rule.desc}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="space-y-3">
        <h5 className="text-sm font-semibold text-foreground flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-success" />
          Effect Types
        </h5>
        <ul className="space-y-2">
          {effectTypes.map((effect) => (
            <li key={effect.name} className="flex items-start gap-2 text-sm">
              <code className="px-1.5 py-0.5 bg-muted rounded text-xs font-mono text-muted-foreground shrink-0">
                {effect.name}
              </code>
              <span className="text-muted-foreground">{effect.desc}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
